import { useEffect } from "react";
import { brandingAssetUrl, brandingVariables } from "./brandingTheme";

export const useBranding = (tenant, enabled = true) => {
  const branding = tenant?.branding;
  useEffect(() => {
    if (!enabled) return undefined;
    const root = document.documentElement;
    const variables = brandingVariables(branding);
    const previous = Object.fromEntries(Object.keys(variables).map((name) => [name, root.style.getPropertyValue(name)]));
    Object.entries(variables).forEach(([name, value]) => root.style.setProperty(name, value));
    const previousTitle = document.title;
    const favicon = document.querySelector("link[rel='icon']");
    const previousFavicon = favicon?.getAttribute("href");
    let activeFavicon = favicon;
    if (branding?.faviconUrl) {
      if (!activeFavicon) {
        activeFavicon = document.createElement("link");
        activeFavicon.rel = "icon";
        document.head.appendChild(activeFavicon);
      }
      activeFavicon.href = brandingAssetUrl(branding.faviconUrl);
    }
    const meta = document.querySelector("meta[name='description']");
    const previousDescription = meta?.getAttribute("content");
    let activeMeta = meta;
    if (branding?.metaDescription) {
      if (!activeMeta) {
        activeMeta = document.createElement("meta");
        activeMeta.name = "description";
        document.head.appendChild(activeMeta);
      }
      activeMeta.content = branding.metaDescription;
    }
    if (branding?.metaTitle || branding?.appName) document.title = branding.metaTitle || branding.appName;
    return () => {
      Object.entries(previous).forEach(([name, value]) => value ? root.style.setProperty(name, value) : root.style.removeProperty(name));
      document.title = previousTitle;
      if (activeFavicon && !favicon) activeFavicon.remove();
      else if (favicon) previousFavicon === null ? favicon.removeAttribute("href") : favicon.setAttribute("href", previousFavicon);
      if (activeMeta && !meta) activeMeta.remove();
      else if (meta) previousDescription === null ? meta.removeAttribute("content") : meta.setAttribute("content", previousDescription);
    };
  }, [branding, enabled]);
};